import { useDeviceOrientation } from '../../Utils/useDeviceOrientation';
import Landscape from '../Landscape';

const RequirePortrait = ({ children }) => {
    const { isLandscape } = useDeviceOrientation();
    return isLandscape ? <Landscape /> : children;
};

export default RequirePortrait;
